import React, {FC} from "react";
import Typography from "@material-ui/core/Typography";
import {ClientDisplay} from "../clients/sharedComponents/ClientDisplay";
import Paper from "@material-ui/core/Paper";
import {makeStyles} from "@material-ui/core/styles";
import {Skeleton} from "@material-ui/lab";
import {FeOrder} from "../orders/redux/types";
import {useHistory} from "react-router-dom";
import {ServiceChip} from "../services/components/ServiceChip";

const useStyles = makeStyles(() => ({
    paper: {
        position: 'relative',
        padding: '6px 16px',
        width: 280,
        cursor: 'pointer'
    }
}));

export const OrderTimelineDisplay: FC<{ order: FeOrder }> = ({order}) => {

    const classes = useStyles();

    const history = useHistory();

    return (
        <Paper
            elevation={3}
            className={classes.paper}
            onClick={() => history.push("/admin/orders/order/" + order.id)}
        >
            <Typography
                variant="h6"
                component="h1"
                color="secondary"
                style={{display: 'inline-flex', alignItems: 'center'}}
            >
                {order && <ClientDisplay clientId={order.clientId}/>}
            </Typography>
            <Typography color={"textSecondary"}>
                {order
                    ? order.serviceAddress.address.formattedAddress :
                    <Skeleton width={160}/>
                }
            </Typography>
            <div style={{marginTop: 4}}>
                {order.servicesIds.map((sId) => (<ServiceChip id={sId}/>))}
            </div>
        </Paper>
    )
}